import type React from 'react';

import { Checkbox } from '@vlabs/uikit/components/controls/checkbox';
import type { WithDataTestid } from '@vlabs/uikit/types';
import type { PathValue } from 'react-hook-form';

import type { EditPermissionsFormProps, PointPermissionPage } from '../types';
import st from './Cell.module.sass';
import { useEditPermissionsFormContext } from '../useEditPermissionsFormContext';

interface PageCellProps extends WithDataTestid {
  page: PointPermissionPage;
  disabled?: boolean;
}

const toggleArrayElement = (arr: string[], val: string): string[] => (
  arr.includes(val)
    ? arr.filter((el) => el !== val)
    : [...arr, val]
);

function PageCell({
  page,
  disabled = false,
  'data-testid': dataTestId = undefined,
}: PageCellProps): React.JSX.Element {
  const { watch, setValue } = useEditPermissionsFormContext();
  const pagesList = watch('pages') ?? [];

  return (
    <div className={st.Cell}>
      <Checkbox
        checked={(pagesList as string[] | undefined)?.includes(page)}
        data-testid={dataTestId}
        disabled={disabled}
        onClick={() => {
          const next = toggleArrayElement(pagesList, page);
          setValue(
            'pages',
            next as PathValue<EditPermissionsFormProps, 'pages'>,
          );
        }}
      />
    </div>
  );
}

export { PageCell };
